import { Link } from "react-router-dom";
import { Star, Zap, Users, Fuel } from "lucide-react";
import { Badge } from "./ui/badge";
import TrustBadges from "./TrustBadges";

export default function CarCard({ car, delay = 0 }) {
  return (
    <Link to={`/cars/${car.car_id}`} data-testid={`car-card-${car.car_id}`}
      className="group block rise" style={{ animationDelay: `${delay}ms` }}>
      <div className="relative overflow-hidden rounded-2xl bg-[#131722] border border-slate-800 hover:border-blue-500/50 transition-all duration-500 hover:-translate-y-1">
        <div className="aspect-[4/3] relative overflow-hidden bg-slate-900">
          {car.photos?.[0] && (
            <img src={car.photos[0]} alt={car.model}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              loading="lazy" />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-transparent to-transparent" />
          <div className="absolute top-3 left-3 flex gap-2">
            {car.dealer_badge && <Badge className="bg-cyan-500/20 text-cyan-300 border border-cyan-500/30 backdrop-blur-md font-mono text-[10px] tracking-wider uppercase" data-testid={`badge-dealer-${car.car_id}`}>Dealer fleet</Badge>}
            {car.gig_ready && (
              <Badge className="bg-emerald-500/20 text-emerald-300 border border-emerald-500/30 backdrop-blur-md font-mono text-[10px] tracking-wider uppercase" data-testid={`badge-gig-ready-${car.car_id}`}>
                <Zap className="w-3 h-3 mr-1" /> Gig Ready
              </Badge>
            )}
            {car.fuel === "electric" && (
              <Badge className="bg-cyan-500/20 text-cyan-300 border border-cyan-500/30 backdrop-blur-md font-mono text-[10px] tracking-wider uppercase">EV</Badge>
            )}
          </div>
          <div className="absolute bottom-3 left-3"><TrustBadges car={car} compact /></div>
          <div className="absolute top-3 right-3 flex items-center gap-1 px-2.5 py-1 rounded-full bg-slate-950/70 backdrop-blur-md border border-slate-800">
            <Star className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" />
            <span className="text-xs font-semibold text-white">{car.rating_avg || "New"}</span>
          </div>
        </div>

        <div className="p-5">
          <div className="flex items-start justify-between gap-3 mb-3">
            <div className="min-w-0">
              <h3 className="font-display font-bold text-lg leading-tight truncate">{car.year} {car.make}</h3>
              <p className="text-slate-400 text-sm truncate">{car.model} {car.trim && `· ${car.trim}`}</p>
            </div>
            <div className="text-right shrink-0">
              <p className="font-display font-extrabold text-xl text-white">${car.daily_price}</p>
              <p className="text-xs text-slate-500 font-mono uppercase tracking-wider">per day</p>
            </div>
          </div>
          <div className="flex items-center gap-4 text-xs text-slate-400 pt-3 border-t border-slate-800">
            <span className="flex items-center gap-1.5"><Users className="w-3.5 h-3.5" />{car.seats}</span>
            <span className="flex items-center gap-1.5"><Fuel className="w-3.5 h-3.5" />{car.fuel}</span>
            <span className="ml-auto text-cyan-300 font-mono text-[10px] tracking-wider uppercase">{car.city}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
